import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { processAuthSession } from '../api';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }
    (async () => {
      try {
        await processAuthSession(sessionId);
        await refresh();
        // Clear the hash and go to dashboard
        window.history.replaceState({}, document.title, '/');
        navigate('/', { replace: true });
      } catch (e) {
        navigate('/login', { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ background: 'var(--lf-bg)' }}
    >
      <div className="flex items-center gap-2 text-sm" style={{ color: 'var(--lf-muted)' }}>
        <Loader2 className="animate-spin" size={16} /> Signing you in…
      </div>
    </div>
  );
}
